'use client';

import HeroSection from './HeroSection';
import BookingTermsSection from './BookingTermsSection';
import CancellationPolicySection from './CancellationPolicySection';
import PaymentTermsSection from './PaymentTermsSection';
import GuestGuidelinesSection from './GuestGuidelinesSection';
import PolicySearchSection from './PolicySearchSection';
import Footer from '@/app/homepage/components/Footer';

export default function BookingPolicyInteractive() {
  return (
    <>
      <HeroSection />
      <PolicySearchSection />
      <BookingTermsSection />
      <CancellationPolicySection />
      <PaymentTermsSection />
      <GuestGuidelinesSection />
      <Footer />
    </>
  );
}